import { usePostApiTimesheetsByUuidRows, } from '../../generated/sitComponents';
import { getTimesheetRowsQueryData, setTimesheetRowsQueryData } from './query';
export function usePostTimesheetRow(options) {
    return usePostApiTimesheetsByUuidRows({
        ...options,
        onMutate: (variables, context) => {
            // Cancel any outgoing refetches
            // (so they don't overwrite our optimistic update)
            // Snapshot the previous value
            const queryData = getTimesheetRowsQueryData(context.client, variables.pathParams.timesheetId);
            const optimisticId = variables.body?.id;
            if (optimisticId) {
                const now = new Date().toISOString();
                // Optimistically update to the new value
                setTimesheetRowsQueryData(context.client, variables.pathParams.timesheetId, (draft) => {
                    if (draft) {
                        const tsRow = {
                            created_at: now,
                            dimensionValues: {
                                BILLABLE: false,
                                CUSTOMER: null,
                                COSTTYPE: null,
                                DEPARTMENT: null,
                                EMPLOYEEPOSITION: null,
                                ITEM: null,
                                LABORCLASS: null,
                                LABORSHIFT: null,
                                LABORUNION: null,
                                LOCATION: null,
                                PROJECT: null,
                                TASK: null,
                                TIMETYPE: null,
                            },
                            id: optimisticId,
                            isTimeClockRow: false,
                            allocationLineId: null,
                            parentId: null,
                            entries: [],
                            negativeHours: variables.body?.negativeHours ?? false,
                            source: 'controller',
                            timesheet_id: variables.pathParams.timesheetId,
                            updated_at: now,
                        };
                        draft.unshift(tsRow);
                    }
                    return draft;
                });
            }
            options?.onMutate?.(variables, context);
            return { queryData };
        },
        onSuccess: (data, variables, onMutateResult, context) => {
            setTimesheetRowsQueryData(context.client, variables.pathParams.timesheetId, (draft) => {
                if (draft) {
                    const idx = draft.findIndex((r) => r.id === data.id);
                    if (idx !== -1) {
                        draft[idx] = data;
                    }
                    else {
                        draft.unshift(data);
                    }
                }
                return draft;
            });
            options?.onSuccess?.(data, variables, onMutateResult, context);
        },
        onError: (error, variables, onMutateResult, context) => {
            const { queryData } = onMutateResult;
            if (queryData) {
                setTimesheetRowsQueryData(context.client, variables.pathParams.timesheetId, () => queryData);
            }
            options?.onError?.(error, variables, onMutateResult, context);
        },
    });
}
//# sourceMappingURL=use-post-timesheet-row.js.map